import { render } from "./SignInRedirect.vue?vue&type=template&id=6e975f80&scoped=true"
import script from "./SignInRedirect.vue?vue&type=script&lang=js"
export * from "./SignInRedirect.vue?vue&type=script&lang=js"

import "./SignInRedirect.vue?vue&type=style&index=0&id=6e975f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e975f80"]])

export default __exports__